export function canConversationTransferToAgent(metaConversation) {
    const { conversation: { direction, status, initial_channel: initialChannel, live_assesment: liveAssessment, }, isAssignedToMe, } = metaConversation;
    let transferToAgentDisabled = false;
    if (direction !== 'internal') {
        if (status === 'closed' ||
            status === 'awaitingpending' ||
            status === 'pending') {
            transferToAgentDisabled = true;
        }
        if (isAssignedToMe === false) {
            transferToAgentDisabled = true;
        }
        // We do not allow transfer to agent if the enduser not is connected and the conversation not is an email.
        if (initialChannel !== 'email' &&
            liveAssessment &&
            liveAssessment.is_end_user_connected === false) {
            transferToAgentDisabled = true;
        }
        if (initialChannel === 'callback') {
            transferToAgentDisabled = true;
        }
        if ((initialChannel === 'contactform' || initialChannel === 'voicemail') &&
            isAssignedToMe === true &&
            status === 'open') {
            transferToAgentDisabled = false;
        }
        if (status === 'closed') {
            if (initialChannel === 'whatsapp') {
                transferToAgentDisabled = true;
            }
        }
    }
    return !transferToAgentDisabled;
}
export function canConversationTransferToQueue(metaConversation, latestMessengerConversation) {
    const { conversation: { direction, status, assignment, id: csid, initial_channel: initialChannel, }, isAssignedToMe, } = metaConversation;
    let transferToQueueDisabled = false;
    if (direction !== 'internal') {
        if (status === 'closed' ||
            status === 'awaitingpending' ||
            status === 'pending') {
            transferToQueueDisabled = false;
        }
        if (isAssignedToMe === false) {
            transferToQueueDisabled = true;
        }
        // BUT we do allow "transfer to queue" if it not assigned to ourselves and it's not assisted to anyone.
        if (isAssignedToMe === false && assignment === null) {
            transferToQueueDisabled = false;
        }
        if ((isAssignedToMe === false && status === 'closed') ||
            status === 'awaitingpending' ||
            status === 'pending') {
            transferToQueueDisabled = false;
        }
        if (status === 'closed') {
            if (initialChannel === 'whatsapp') {
                transferToQueueDisabled = true;
            }
            if (initialChannel === 'facebookmessenger') {
                if ((csid !== null && csid !== void 0 ? csid : -1) < (latestMessengerConversation !== null && latestMessengerConversation !== void 0 ? latestMessengerConversation : 0)) {
                    transferToQueueDisabled = true;
                }
            }
        }
    }
    return !transferToQueueDisabled;
}
export function canConversationTransferToNumber(metaConversation, staticTelephoneNumbers) {
    const { conversation: { direction, status, attributes, initial_channel: initialChannel, live_assesment: liveAssessment, }, isAssignedToMe, } = metaConversation;
    let transferToNumberDisabled = true;
    if (direction !== 'internal') {
        // Only allow blind/assisted transfer on phone conversations and callbacks.
        if (initialChannel === 'pstnphone') {
            transferToNumberDisabled = false;
        }
        if (status === 'closed' ||
            status === 'awaitingpending' ||
            status === 'pending') {
            transferToNumberDisabled = true;
        }
        if (isAssignedToMe === false) {
            transferToNumberDisabled = true;
        }
        // We do not allow "transfer to number" if the number called not is verified for outbound.
        if (attributes && attributes.called_number) {
            // We find the number in our staticTelephoneNumbersArray.
            const foundNumber = staticTelephoneNumbers.find(({ e164_format }) => {
                var _a, _b;
                return e164_format ===
                    ((_b = (_a = metaConversation === null || metaConversation === void 0 ? void 0 : metaConversation.conversation) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.called_number);
            });
            // We do not allow blind and assisted transfer if the outgoing_functionality is false.
            if (foundNumber && foundNumber.outgoing_functionality === false) {
                transferToNumberDisabled = true;
            }
        }
        // We do not allow transfer to number if the enduser not is connected and the conversation not is an email.
        if (initialChannel !== 'email' &&
            liveAssessment &&
            liveAssessment.is_end_user_connected === false) {
            transferToNumberDisabled = true;
        }
        if (status === 'closed') {
            if (initialChannel === 'whatsapp') {
                transferToNumberDisabled = true;
            }
        }
    }
    return !transferToNumberDisabled;
}
